import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONSTANTES } from "../shared/global";

@Injectable({
    providedIn: 'root'
})
export class ObservationService {

    public url: string;

    constructor(private http: HttpClient) {
        this.url = CONSTANTES.api_url + "/observations";
    }

    /**Obtiene todas los rangos de las observaciones*/
    getInfoObservation() {
        const iheaders = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.get<any>(this.url + "/all", { headers: iheaders });
    }
}
